import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

function Texts(props) {
  const {
    tag: TagName,
    children,
    theme,
    type,
    className,
    dataQa,
    id,
    style,
  } = props;

  if (!children) return null;

  const textAtoms = theme.texts[type] || theme.texts.body;

  const scope = textAtoms.letterSpacing
    ? resolveScopedStyles(
      <scope>
        <style jsx>{`
          .letterSpacing
            letter-spacing ${textAtoms.letterSpacing}
        `}</style>
      </scope>
    ) : null;

  const elementProps = {
    className: cx('texts', scope && scope.wrapClassNames('letterSpacing'), className),
    ...dataQa && { 'data-qa': dataQa },
    id,
    style,
  };

  return (
    <>
      <style jsx>{`
        .texts
          font ${textAtoms.font}
          color ${textAtoms.color}
        `}</style>
      <TagName {...elementProps}>{children}</TagName>
      {textAtoms.letterSpacing && <scope.styles />}
    </>
  );
}

Texts.propTypes = {
  /**
   * Имя текстового атома, в наборе theme.texts
   */
  type: PropTypes.string.isRequired,
  /**
   * Имя класса для дополнительной стилизации
   */
  className: PropTypes.string,
  /**
   *  Разметка для автотестов UI
   */
  dataQa: PropTypes.string,
  /**
   * Тег, в котором будет отрендерен контент
   */
  tag: PropTypes.string,
  /**
   * Id элемента
   */
  id: PropTypes.string,
  /**
   * Inline стили
   */
  style: PropTypes.object,
  /** @ignore */
  theme: PropTypes.object,
};

Texts.defaultProps = {
  tag: 'div',
  type: 'body',
};

const TextsWithHOCs = withTheme(Texts);
TextsWithHOCs.displayName = 'Texts';

export { Texts as StorybookComponent };
export default TextsWithHOCs;
